const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/customers/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
export const customerSchema = z.object({
  customerId: z.number().optional()
});
export const Route = createFileRoute('/(app)/org/$org/idea-management/customers/')({
  beforeLoad: async ({
    context: {
      flags
    }
  }) => {
    if (!flags.fimCustomersEnabled) {
      throw notFound();
    }
  },
  validateSearch: zodValidator(customerSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {}
  }
});